import React from 'react';
import { TableBody, TableRow, TableCell, IconButton } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { EyeOpenedIcon, PlusIcon } from '@stash-ui/regular-icons';

const Body = ({ tableRow, rowContent, path, useUid, action, customActions, isSlug }) => {
  const history = useHistory();

  const renderObjectItem = obj => {
    if (!obj) return;
    let res = '';

    for (let item in obj) {
      const value = obj[item];

      if (typeof value === 'symbol' || React.isValidElement(value)) {
        return obj;
      } else {
        res += `${item}: ${String(value)}, `;
        return res;
      }
    }
    return res;
  };

  return (
    <TableBody>
      {tableRow.map(row => (
        <TableRow key={row.id} data-testid="tableRow">
          {rowContent.map(objKey => (
            <TableCell
              data-testid="tableCell"
              onClick={() => {
                if (objKey == 'userId') {
                  history.push(`/users/${row[objKey]}`);
                }
                if (objKey === 'channelId' || objKey === 'toChannelId') {
                  history.push(`/channels/searchItem=id&search=${row[objKey]}`);
                }
              }}
              key={objKey}
            >
              {typeof row[objKey] === 'object' ? renderObjectItem(row[objKey]) : row[objKey]}
            </TableCell>
          ))}
          <TableCell data-testid="tableCell">
            {customActions?.map(btn => {
              return <IconButton onClick={() => btn?.action(row)}>{btn?.icon}</IconButton>;
            })}
            {action && (
              <Link to={`/${path}/${isSlug ? row.slug : !useUid ? row.id : row.uid}`}>
                <IconButton>{action === 'edit' ? <PlusIcon title="Edit" /> : <EyeOpenedIcon title="Check it out" />}</IconButton>
              </Link>
            )}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default Body;
